export const isLocalMode = () => process.env.NODE_ENV === 'development';

export const isTestOrLocalDb = () => {
  const nodeEnv = process.env.NODE_ENV;
  const dbEnv = process.env.DB_ENV;

  return nodeEnv === 'test' || (nodeEnv === 'development' && (dbEnv === 'emptylocaldb' || dbEnv === 'localdb'));
};

export const isEmptyLocalDb = () => {
  const nodeEnv = process.env.NODE_ENV;
  const dbEnv = process.env.DB_ENV;

  return (nodeEnv === 'test' || nodeEnv === 'development') && dbEnv === 'emptylocaldb';
};

export const localDbLocation = () => process.env.ASKAI_LOCALDB_LOCATION || process.env.HOME || '';

export const sleep = async (ms: number): Promise<void> => new Promise((resolve) => setTimeout(resolve, ms));
